<sc-title>{{'details station group' | translate: ['tmc.admin.yard-structure.stationgroup-details.title',
  translationService.language]}}</sc-title>
<sc-content-spacer [vertical]="true"></sc-content-spacer>
<div class="mask">
  <sc-flex [vertical]="true" [stretchContent]="true" *ngIf="stationGroup != null">
    <mat-form-field class="stationGroupProperty" appearance="fill">
      <mat-label>{{'name' | translate: ['tmc.stationgroup.name', translationService.language]}}</mat-label>
      <input [(ngModel)]="stationGroup.name" #ctrl="ngModel" name="stationGroupName" matInput [required]="true"
        [maxlength]="255" />
    </mat-form-field>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <mat-form-field class="stationGroupProperty" appearance="fill">
      <mat-label>
        {{'Type' | translate: ['tmc-yard.entity.station-group.station-group-type', translationService.language]}}
      </mat-label>
      <mat-select [(ngModel)]="stationGroup.stationGroupType" name="stationGroupType">
        <mat-option *ngFor="let o of stationGroupTypes" value="{{o}}">
          {{o | translate: ['tmc-yard.entity.station-group.station-group-type.' + o, translationService.language]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <mat-form-field class="stationGroupProperty" appearance="fill">
      <mat-label>{{'externalKey' | translate: ['tmc.stationgroup.externalKey', translationService.language]}}
      </mat-label>
      <input [(ngModel)]="stationGroup.externalKey" name="{{'stationGroupExternalKey' }}" matInput
        #sgExternalKeyCtrl="ngModel" [required]="true" [maxlength]="50" [minlength]="1" />
    </mat-form-field>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <mat-form-field class="stationGroupProperty" appearance="fill">
      <mat-label>{{'description' | translate: ['tmc.stationgroup.description', translationService.language]}}
      </mat-label>
      <textarea [(ngModel)]="stationGroup.description" name="{{'stationGroupDescription' }}" matInput [required]="false"
        [maxlength]="255"></textarea>
    </mat-form-field>
  </sc-flex>
</div>
